/* The summary and detailed reviews share one request for the same product. */
(() => {
  const requests = (window.libaseProductReviewRequests ||= new Map());
  window.libaseLoadProductReviews ||= (handle) => {
    const url = `https://libase-gacha.onrender.com/reviews?productId=${encodeURIComponent(handle)}`;
    if (!requests.has(url)) {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 12000);
      const request = fetch(url, { credentials: 'omit', signal: controller.signal })
        .then((response) => {
          if (!response.ok) throw new Error('review_request_failed');
          return response.json();
        })
        .finally(() => window.clearTimeout(timeout));
      requests.set(url, request);
      request.catch(() => requests.delete(url));
    }
    return requests.get(url);
  };

  if (customElements.get('libase-review-summary')) return;
  customElements.define('libase-review-summary', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      const label = this.querySelector('[data-review-label]');
      const stars = this.querySelector('[data-review-stars]');
      window.libaseLoadProductReviews(this.dataset.productHandle)
        .then((data) => {
          if (!data?.ok || !Array.isArray(data.reviews)) throw new Error('invalid_reviews');
          const ratings = data.reviews.map((review) => Number(review.rating))
            .filter((rating) => Number.isFinite(rating) && rating >= 1 && rating <= 5);
          if (!ratings.length) {
            label.textContent = 'この商品のレビューはまだありません';
            return;
          }
          const average = ratings.reduce((total, rating) => total + rating, 0) / ratings.length;
          if (stars.querySelector('[data-review-fill]')) {
            stars.querySelector('[data-review-fill]').style.width = `${average / 5 * 100}%`;
          } else {
            stars.innerHTML = `<span>★★★★★</span><span data-review-fill style="width:${average / 5 * 100}%">★★★★★</span>`;
            stars.classList.add('libase-summary-stars');
          }
          stars.hidden = false;
          label.textContent = `${average.toFixed(1)} / 5（${ratings.length}件）`;
          this.querySelector('a').setAttribute('aria-label', `この商品の評価 5点中${average.toFixed(1)}点、${ratings.length}件のレビューを見る`);
        })
        .catch(() => { label.textContent = '商品レビューを確認する'; });
    }
  });
})();
